import request from '@/utils/request'
const qs = require('qs')

// 登录
export function login(params) {
  return request({
    url: '/login',
    method: 'post',
    data: qs.stringify(params)
  })
}
export function logout(params) {
  return request({
    url: '/logout',
    method: 'post',
    data: params
  })
}
// 获取用户 website 配置
export function userWebConfig(params) {
  return request({
    url: '/bigScreen/user/webConfig',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 当前登录用户修改密码
export function userModifyPwd(params) {
  return request({
    url: '/user/modifyPwd',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 当前登录用户修改密码
export function checkToken(params) {
  return request({
    url: '/check',
    method: 'post',
    data: qs.stringify(params)
  })
}
